import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import { Typography } from 'material-ui'

const styles = theme => ({
  comingsoon: {
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    backgroundColor: 'white',
    width: '60%',
    padding: window.innerWidth * 0.2,
    textAlign: 'center',
    left: 0
  }
})

@withStyles(styles)
export default class ComingSoon extends Component {
  render() {
    const { classes } = this.props

    return (
      <div>
        <div id="comingsoon" className={classes.comingsoon}>
          <img
            alt=""
            style={{ width: window.innerWidth * 0.6 }}
            src={this.props.img}
          />
          <Typography variant="display1">
            <br /> Coming Soon <br />
            <br />
          </Typography>
          <Typography variant="subheading">
            {this.props.track}
            <br />
          </Typography>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/comingsoon.js